import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-selezionati',
  standalone: true,
  templateUrl: './selezionati.component.html',
  styleUrls: ['./selezionati.component.scss'],
  imports: [ReactiveFormsModule, MdbFormsModule, MdbSelectModule,
    MdbTableModule, CommonModule
  ]
})
export class SelezionatiComponent implements OnInit {
  storico: any = []
  markets: any = []
  days: any = [
    {value: 2, label: 'Lunedì'},
    {value: 3, label: 'Martedì'},
    {value: 4, label: 'Mercoledì'},
    {value: 5, label: 'Giovedì'},
    {value: 6, label: 'Venerdì'},
  ]
  oraOpen: any = []
  headers: any = [
    'Market',
    'Dayweek',
    'Open',
    'Close',
    'Punti',
    'Num. Op.',
    'Punti Op.',
    'Perc. Pos.',
    'Rawal',
    'Kelly',
    'Sel.'
  ]
  tableData: any = []
  formFiltri: FormGroup = new FormGroup({
    selMarket: new FormControl(null),
    selDayweek: new FormControl('0'),
    selRawal: new FormControl(null),
    selOpen: new FormControl(0),
    selezionato: new FormControl(null)
  })
  constructor(private service: FrattaleService) { 
    for(let i: number = 2; i<24; i++){
      this.oraOpen.push(i)
    }
  }

  ngOnInit(): void {
    this.service.fractimeSelezionati().subscribe((data:any)=>{
      console.log(data)
      if(data.res=='ok'){
        this.tableData = data.data
        this.tableData.forEach((el:any)=>{
          el.rawal = -el.rawal
          //el.percpos = el.punti > 0 ? el.percpos : 1 - el.percpos
          //el.kelly = el.percpos - (1-el.percpos)/el.rawal
        })
        this.storico = data.data
      }
    })
    this.service.getMarketsSymbols().subscribe((data:any)=>{
      this.markets = data.data
    })
  }

  selectMarket(){
    this.tableData = this.storico
    let mkt = this.formFiltri.get('selMarket')?.value
    if(mkt){
      mkt = mkt.toLowerCase()
      this.tableData = this.storico.filter((el:any)=>el.market==mkt)
    }
    let gg = this.formFiltri.get('selDayweek')?.value
    if(gg>0){
      this.tableData = this.tableData.filter((el:any)=>el.dayweek==gg)
    }
    let open = this.formFiltri.get('selOpen')?.value
    if(open>0){
      this.tableData = this.tableData.filter((el:any)=>el.oraopen==open)
    }
  }

  selezionaTS(id: number,ts: any){
    this.service.fractimePref(id, ts.checked ).subscribe((data:any)=>{
    })
  }

}
